import React, { useState, useRef } from 'react';

import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateJobApplicant } from '../../action/application/update-job-applicant';
import { userSelector } from '../../reducers/current-user-selectors';

import { uploadFileViaEmployer } from '../../api/file-upload-api-client';
import { UiButton } from '../../ui/ui-button';

import { RESUMES_BUCKET } from '../../config/aws-config';

export const ACCEPTED_RESUME_TYPES = '.pdf,.doc,.docx,.jpg,.png';

const mapStateToProps = (state: any) => ({
  user: userSelector(state),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { jobApplicant }: InputProps,
) => ({
  actions: {
    updateJobApplicant: (update: {
      resumeUploadedByName: string;
      resumeUploadedBy: string;
      resumeUploadedAt: Moment;
      resumeFileName: string;
    }) => dispatch(updateJobApplicant(jobApplicant.job_applicant_id, jobApplicant.orgId, update)),
  },
});

type InputProps = {
  jobApplicant: FullApplicant;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const UploadResume = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ jobApplicant, user, actions }: Props) => {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const inputRef = useRef<any>();

  const handleAddResumeClick = async () => {
    inputRef.current.click();
  };

  const handleFileUploadClick = async ({
    target: { files },
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (!files || files.length === 0 || !user.username) {
      return;
    }
    const resume = files[0];

    setIsUploading(true);
    const fileKey = `application/${jobApplicant.job_application_hash}/${resume.name}`;
    try {
      await uploadFileViaEmployer(fileKey, resume, RESUMES_BUCKET, 'public-read');
      await actions.updateJobApplicant({
        resumeUploadedByName: `${user.firstName} ${user.lastName}`,
        resumeUploadedBy: user.username,
        resumeUploadedAt: moment().utc(),
        resumeFileName: resume.name,
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        hidden
        type="file"
        accept={ACCEPTED_RESUME_TYPES}
        onChange={handleFileUploadClick}
      />
      <UiButton size="sm" onClick={handleAddResumeClick} loading={isUploading} variant="secondary">
        Upload a Resume
      </UiButton>
    </>
  );
});
